import Modal from 'react-bootstrap/Modal'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'


function DeleteInformacion(props) {
	const { informacion, mostrar, setQueMostrar, eliminarInformacion } = props

	const handleClose = () => {
		setQueMostrar('')
	}
	
	return (
		<Modal show={mostrar} onHide={handleClose}>
			<Modal.Header closeButton>
				<Modal.Title>Eliminar Información</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Alert variant="danger">
					Está a punto de eliminar la información <strong>{`${informacion.titulo}`}</strong>. Esta acción no se puede deshacer.
				</Alert>
				<p>¿Está seguro que desea continuar?</p>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="outline-tertiary" onClick={handleClose}>
					Cancelar
				</Button>
				<Button variant="primary" onClick={() => eliminarInformacion(informacion.id)}>
					Eliminar
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

export default DeleteInformacion